
import { MeetingErrorInterface } from "@api/models/interfaces/meetings-schedule/MeetingsScheduleErrorInterface";
import { MeetingsErrorCode } from "@api/enums/errors/Meetings";
import { Modal } from "@common/Modal";
import i18n from "@service/locale/i18";

export class MeetingsError implements MeetingErrorInterface {

    constructor(public code: MeetingsErrorCode, public message: string) {
    }

    async showModal() {
        let text = "";

        switch (this.code) {
            case MeetingsErrorCode.userHasSlotAtThisSchedule:
                text = i18n.t("meetings.slot.userHasSlotAtThisSchedule").toString()
                break;
            case MeetingsErrorCode.userHasSlotAtThisPeriod:
                text = i18n.t("meetings.slot.userHasSlotAtThisPeriod").toString()
                break;

            default:
                break;
        }

        const modal = new Modal({
            title: "Error",
            contentText: text || "Unknow Error",
            buttons: [
                {
                    text: 'Ok',
                    class: 'is-green is-middle',
                    returnValue: true
                }
            ]
        });

        return await modal.showConfirm();
    }


    static isValid(code: MeetingsErrorCode | string) {
        const codes: string[] =
            [
                MeetingsErrorCode.userHasSlotAtThisSchedule,
                MeetingsErrorCode.userHasSlotAtThisPeriod
            ]

        return codes.includes(code);
    }
}
